<template>
    <div class="tw-flex tw-flex-col tw-h-64 tw-justify-center tw-items-center">
        <div class="tw-text-3xl tw-font-bold tw-tracking-normal tw-mb-8" v-html="title"></div>
        <div class="tw-text-grey-dark tw-font-light tw-mb-8 tw-text-center" v-html="description"></div>
        <a class="btn btn-default tw-px-10" v-text="button.caption" @click="openModal"></a>
    </div>
</template>
<script type="text/babel">
    import modalMixin from '../mixins/modal-button';
    export default {
        name: 'EmptyState',
        mixins: [modalMixin],
        props: {
            title: {type: String, required: true},
            description: {type: String, required: true},
            button: {type: Object, required: true},
            modal: {type: Object, required: false},
            modalTarget: {type: String, required: true},
        }
    }
</script>
